import axios from 'axios';

const actions = {
  async getlogin({ context }, params) {
    try {
      const res = await axios.post(`${this.state.API_URL}/login.php`, params);
      return res.data;
    } catch (error) {
      return error;
    }
  },
   
  async updatelogin({context},params){
    try {
      const res=await axios.post(`${this.state.API_URL}/updatelogin.php`,params);
      return res.data;
    } catch (error) {
      return error;
    }
  }
 
};
const mutations = {};
const state = {};
export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
